import React, { useRef, useState } from 'react';
import * as XLSX from 'xlsx';
import { toast } from 'react-hot-toast';
import api from 'connections/api';
import routes_api from 'connections/routes_api';

// ##### UPDATE BATCH CARD - FLOWS UPLOAD
const CustomFlowsUpload = ({ reload }) => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [parsedData, setParsedData] = useState([]);
  const [isImporting, setIsImporting] = useState(false);

  const resetState = () => {
    setSelectedFile(null);
    setParsedData([]);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSelectedFile(file);

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const binaryStr = event.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(worksheet);
        setParsedData(data);
        toast.success('File loaded successfully');
      } catch (err) {
        console.error(err);
        toast.error('Failed to read file');
        resetState();
      }
    };
    reader.readAsBinaryString(file);
  };

  const createManyFinancialFlows = async (payload) => {
    await api.post(routes_api.finance_flows_createmany, payload);
  };

  const handleImport = async () => {
    if (parsedData.length === 0) {
      toast.error('No data to import');
      return;
    }
    try {
      setIsImporting(true);
      await createManyFinancialFlows(parsedData);
      toast.success('Imported successfully (append)');
      resetState();
      if (reload) reload();
    } catch (err) {
      console.error(err);
      toast.error('Error importing records');
    } finally {
      setIsImporting(false);
    }
  };

  const buttonBase = 'px-6 py-3 rounded-xl shadow-md text-white';
  const importDisabled = 'bg-gray-400 cursor-not-allowed';
  const importEnabled = 'bg-emerald-600 hover:bg-emerald-700';

  return (
    <>
      <div className="flex flex-col gap-3">
        <div className="flex flex-col sm:flex-row gap-3">
          <label className="flex-1 cursor-pointer bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl shadow-md text-center">
            Select Excel to Upload Flows
            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileSelect}
              className="hidden"
            />
          </label>
          <button
            onClick={handleImport}
            disabled={!selectedFile || isImporting}
            className={`${buttonBase} ${!selectedFile || isImporting ? importDisabled : importEnabled}`}
            style={{ minWidth: '180px' }}
          >
            {isImporting ? 'Uploading...' : 'Upload Flows'}
          </button>
        </div>
        <div className="text-sm text-gray-700">
          Uploaded file: <strong>{selectedFile?.name || 'none'}</strong>
        </div>
      </div>
    </>
  );
};

export default CustomFlowsUpload;
